import { requestApi } from '../Api';

export const readModifiers = (navigate, params) => {
  return requestApi({ url: '/api/admin/databank/modifiers/read', params, navigate });
};

export const createModifier = (navigate, params) => {
  return requestApi({ url: '/api/admin/databank/modifiers/create', params, navigate });
};

export const updateModifier = (navigate, params) => {
  return requestApi({ url: '/api/admin/databank/modifiers/update', params, navigate });
};

export const deleteModifier = (navigate, params) => {
  return requestApi({ url: '/api/admin/databank/modifiers/delete', params, navigate });
};

export const restoreModifier = (navigate, params) => {
  return requestApi({ url: '/api/admin/databank/modifiers/restore', params, navigate });
};
